vue cam
<template>
  <video
    v-if="ready"
    ref="video"
    autoplay
    :width="width"
    :height="height"
  ></video>
</template>

<script src="https://webrtc.github.io/adapter/adapter-latest.js"></script>

<script>
export default {
  props: ["deviceId"],
  data() {
    return {
      width: null,
      height: null,
      ready: true,
    };
  },
  watch: {
    async deviceId(v) {
      await this.stopVideo();
      if (!v) return;
      this.ready = true;
      this.showVideo();
      this.$forceUpdate();
    },
  },
  methods: {
    later(delay) {
      return new Promise(function (resolve) {
        setTimeout(resolve, delay);
      });
    },
    handleResize() {
      this.width = window.innerWidth;
      this.height = window.innerHeight;
    },

    async stopVideo() {
      // let constraints = {
      //   audio: false,
      //   video: false,
      // };
      this.turnOffVideo();
      //this.ready = false;
      await this.later(2000);

      // navigator.
      // navigator.mediaDevices
      //   .getUserMedia(constraints)
      //   .then((stream) => {
      //     try {
      //       this.$el.srcObject = stream;
      //     } catch (error) {
      //       this.$el.srcObject = URL.createObjectURL(stream);
      //       alert(err.name + ": " + err.message);
      //     }

      //     //info.innerHTML+= "<pre>DONE</pre>";
      //     console.log("DONE");
      //   })
      //   .catch((err) => {
      //     alert(err.name + ": " + err.message);
      //   });
    },
    showVideo() {
      let constraints = {
        audio: false,
        video: {
          deviceId: { ideal: this.deviceId },
          // width: { ideal: this.width },
          // height: { ideal: this.height },
        },
      };

      navigator.mediaDevices
        .getUserMedia(constraints)
        .then((stream) => {
          try {
            this.$el.srcObject = stream;
          } catch (error) {
            this.$el.srcObject = URL.createObjectURL(stream);
            alert(err.name + ": " + err.message);
          }

          //info.innerHTML+= "<pre>DONE</pre>";
          console.log("DONE");
        })
        .catch((err) => {
          alert(err.name + ": " + err.message);
        });
    },
    turnOffVideo() {
      try {
        const video = this.$el;

        // A video's MediaStream object is available through its srcObject attribute
        const mediaStream = video.srcObject;
        console.log(mediaStream)
        if(!mediaStream) return;

        // Through the MediaStream, you can get the MediaStreamTracks with getTracks():
        const tracks = mediaStream.getTracks();

        tracks.forEach((track) => { track.stop(); console.log('stop')});
        // Tracks are returned as an array, so if you know you only have one, you can stop it with:
        //tracks[0].stop();

        // Or stop all like so:
        tracks.forEach((track) => track.stop());
      } catch (err) {
        alert(err.name + ": " + err.message);
      }
    },
  },
  created() {
    window.addEventListener("resize", this.handleResize);
  },
  destroyed() {
    this.turnOffVideo();
    console.log("video destroi");

    window.removeEventListener("resize", this.handleResize);
  },
  mounted() {
    this.$nextTick(() => {
      this.width = window.innerWidth;
      this.height = window.innerHeight;
    });

    if (this.deviceId) {
      this.showVideo();
      this.$forceUpdate();
    }

    // navigator.mediaDevices
    //   .enumerateDevices()
    //   .then((devices) => {
    //     let allDevices = devices.filter((v) => v.kind == "videoinput");
    //     devices = devices.filter((v) => v.kind == "videoinput");
    //     console.log("Found " + devices.length + " video devices");

    //     let lastDevice = devices[devices.length - 1];
    //     devices = devices.filter((v) => v.label.indexOf("back") > 0);

    //     let device = null;
    //     if (devices.length > 0) {
    //       console.log("Taking a 'back' camera");
    //       device = devices[devices.length - 1];
    //     } else {
    //       console.log("Taking last camera");
    //       device = lastDevice;
    //     }

    //     if (!device) {
    //       console.log("No devices!");
    //       return;
    //     }

    //     let constraints = {
    //       audio: true,
    //       video: {
    //         deviceId: { ideal: this.deviceId ? this.deviceId : allDevices[0].deviceId },
    //         width: { ideal: window.innerWidth },
    //         height: { ideal: window.innerHeight },
    //       },
    //     };

    //     navigator.mediaDevices
    //       .getUserMedia(constraints)
    //       .then((stream) => {
    //         try {
    //           this.$el.srcObject = stream;
    //         } catch (error) {
    //           this.$el.srcObject = URL.createObjectURL(stream);
    //         }

    //         //info.innerHTML+= "<pre>DONE</pre>";
    //         console.log("DONE");
    //       })
    //       .catch((err) => {
    //         console.log(err.name + ": " + err.message);
    //       });
    //   })
    //   .catch((err) => {
    //     console.log(err.name + ": " + err.message);
    //   });
  },
};
</script>
